module.exports = __webpack_public_path__ + "img/add_btn_icon210.bcedf205.svg";